"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HideIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_389_219)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 8s-.506.777-1.372 1.746c-.709-.468-1.706-1.012-3.014-1.727l-.632-.345a3 3 0 00-4.221-2.407c-.318-.195-.624-.385-.918-.568-.692-.43-1.32-.821-1.89-1.137C5.14 2.67 6.523 2 8 2c4.418 0 8 6 8 6zm-8 5.5c1.26 0 2.45-.447 3.51-1.086-.82-.382-1.763-.89-2.84-1.49a3.001 3.001 0 01-3.526-2.003C3.312 7.858 1.98 7.082 1.097 6.44.4 7.33 0 8 0 8s3.582 5.5 8 5.5zM.67 5.12a1 1 0 01.99-1.738l13.789 7.862a1 1 0 11-.99 1.737L.67 5.12z"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_389_219"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 0h16v16H0z"
  })))))
});
HideIcon.displayName = 'HideIcon';
var _default = exports.default = HideIcon;